export const MERCEDES_XENTRY_SYNC = 'MERCEDES_XENTRY_SYNC';
